const viewMoreIntegrations = document.querySelector('#viewMoreIntegrations');

// Dropdown and Tabs imports
const dropdownWrapper = document.querySelector('.dropdown-wrap');
const dropdownBtn = document.querySelector('.dropdown-btn');
const categories = [...document.querySelectorAll('.list--item')];
const listItems = document.querySelectorAll(
  '.integration-list-wrapper .list--item',
);

// Card list imports
const integrationCardList = document.querySelector('.integration-card-list');
const cards = integrationCardList.querySelectorAll('.card');
const moreCards = document.querySelectorAll('.more-all-cards');
const noResultsFound = document.querySelector('.no-results');
const categoryHeading = document.getElementById('category-heading');

// Search container imports
const searchResultInner = document.querySelector('.search-result');
const searchField = document.getElementById('search-field');
const closeBtn = document.getElementById('close-btn');

const integrationSection = document.getElementById('integration');
// Integration form imports
const integrationFormContainer = document.getElementById('integration-request');
const integrationForm = integrationFormContainer.querySelector('#integration-form');
const thankYouCard = integrationFormContainer.querySelector('#thank-you');
const closeFormBtn = integrationFormContainer.querySelectorAll('.close');
const toggleFormBtn = document.querySelectorAll('.toggleIntegrationForm');
const integrationNameInput = document.getElementById('integration-name');

export default function setIntegrationFoldToDefault() {
  // Reseting the state for the cards and input fields
  searchField.value = ''; // clear the input field
  closeBtn.classList.add('hide'); // hide the close icon
  noResultsFound.classList.add('hide'); // hide the no result container
  integrationCardList.classList.remove('hide'); // show the cards list
  searchResultInner.innerHTML = ''; // clear the search results
  if (categoryHeading.innerText.includes('All integrations')) {
    viewMoreIntegrations.classList.remove('hide'); // show the view more button
  }
}

if (dropdownBtn) {
  dropdownBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    dropdownWrapper.classList.toggle('is-open');
  });
}

// Mobile dropdown
categories.forEach((listItem) => {
  listItem.addEventListener('click', () => {
    categories.map(item => item.closest('li').classList.remove('active'));

    listItem.closest('li').classList.add('active');
    if (dropdownBtn) {
      const dropdownBtnText = dropdownBtn.querySelector('.category-text');
      dropdownBtnText.innerHTML = listItem.innerText;
      dropdownWrapper.classList.remove('is-open');
    }
  });
});

// Desktop tabs
listItems.forEach((item) => {
  item.addEventListener('click', (e) => {
    // Calculate the scroll position based on the position of the search container
    const navbarOffset = 80;
    const scrollToY = integrationSection.getBoundingClientRect().top
                        + window.pageYOffset - navbarOffset;
    window.scrollTo({
      top: scrollToY,
      behavior: 'smooth',
    });

    setIntegrationFoldToDefault();
    viewMoreIntegrations.classList.add('hide'); // show the view more button
    categoryHeading.innerHTML = `${item.innerText}<span class="dot">.</span>`;

    // Get the category ID from the closest parent li element
    const categoryId = e.target.closest('li').getAttribute('data-category-id');

    // Add the 'hide' class on those cards which are not the one that matches the category ID
    cards.forEach((card) => {
      card.classList.toggle('hide', !card.classList.contains(categoryId));
    });

    // If the category ID is 'all-card', hide all cards having more-cards class and
    // show the view more button
    if (categoryId === 'all-card') {
      moreCards.forEach((card) => {
        card.classList.add('hide');
      });
      viewMoreIntegrations.classList.remove('hide');
    }
  });
});

// Open the Integration request form
toggleFormBtn.forEach((btn) => {
  btn.addEventListener('click', () => {
    const inputValue = searchField.value;
    integrationNameInput.value = inputValue.trim();
    integrationFormContainer.classList.remove('hide');
    if (integrationNameInput.value === '') {
      integrationNameInput.focus();
    } else {
      document.getElementById('integrationRequest').focus();
    }
    document.body.classList.add('no-scroll');
  });
});

// View more integrations
function isElementInView(elem) {
  const elemPosition = elem.getBoundingClientRect();
  return (elemPosition.top <= (window.innerHeight || document.documentElement.innerHeight));
}

function showMoreIntegrations() {
  const hiddenCards = document.querySelectorAll('.integration-card-list .card.hide');
  hiddenCards.forEach((card) => {
    if (isElementInView(card)) {
      if (card.classList) {
        card.classList.remove('hide');
      }
    }
  });
  if (viewMoreIntegrations) {
    setTimeout(() => {
      viewMoreIntegrations.classList.add('hide');
    }, 500);
  }
}

viewMoreIntegrations.addEventListener('click', showMoreIntegrations);

// Close the Integration request form

const closeModalPopup = () => {
  integrationFormContainer.classList.add('hide'); // close the form/thank your card
  document.body.classList.remove('no-scroll'); // enable the scroll for the page

  // Show the integration form container and hide the thank you card - default state
  integrationForm.classList.remove('hide');
  thankYouCard.classList.add('hide');
  ['#integration-name', '#integration-email', '#integrationRequest'].forEach((input) => {
    document.querySelector(input).classList.remove('invalid');
  });
};

closeFormBtn.forEach((btn) => {
  btn.addEventListener('click', () => {
    closeModalPopup();
  });
});

integrationFormContainer.addEventListener('click', (e) => {
  e.stopPropagation();
  if (!integrationFormContainer.classList.contains('hide') && !integrationForm.contains(e.target) && !thankYouCard.contains(e.target)) {
    closeModalPopup();
  }
});
